import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-pie',
	templateUrl: './item-pie.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ItemPieComponent implements OnInit, OnDestroy {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() percent: any | undefined;
	
	vm: any = undefined;
	timer: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.handleValueUpdate();

		var currentPercent = undefined;
		this.timer = this.angularHelperService.createInterval(() => {
			if (this.vm.percent !== currentPercent) {
				currentPercent = this.vm.percent;
				this.handleValueUpdate();
			}
		}, 500);
	}
	
	ngOnDestroy() {
		if (this.timer) {
			this.angularHelperService.cancelInterval(this.timer);
		}
	}
	
	handleValueUpdate() {
		this.vm.value = Math.min(Math.min(Math.max(0, this.vm.percent || 0), 100));
		if (this.vm.value < 0 || this.vm.value > 100) {
			this.vm.percentStyle = { opacity: 0};
		} else {
			this.vm.percentStyle = {'--percent': this.vm.value };
		}
	}
	
}